import TeamIcon from "@mui/icons-material/People";
import type { ClassNameMap } from "@mui/material";
import clsx from "clsx";
import { Route, Routes, useParams } from "react-router";

import { ProjectClient } from "@citrine/resources/project";
import type { Team } from "@citrine/resources/team";
import { TeamClient } from "@citrine/resources/team";

import * as sx from "./index.sx";

export function RoutedNavbarTeamInfo() {
  return (
    <Routes>
      <Route path="data-manager/teams/:teamId">
        <Route index path="*" element={<NavbarTeamInfo />} />
      </Route>
      <Route path="projects/:projectId">
        <Route index path="*" element={<NavbarTeamInfo />} />
      </Route>
      {/* ignore other paths; this will suppress test warnings */}
      <Route index path="*" element={null} />
    </Routes>
  );
}

function NavbarTeamInfo() {
  const { projectId, teamId } = useParams<{
    projectId?: string;
    teamId?: string;
  }>();
  const projectQuery = ProjectClient.getInstance().useGet(projectId);
  const teamQuery = TeamClient.getInstance().useGet(teamId);
  return <TeamInfo team={teamQuery.data ?? projectQuery.data?.team} />;
}

type TeamInfoClassKey = "container" | "icon" | "name";

export function TeamInfo({
  className,
  team,
  classes,
}: {
  className?: string;
  team?: Team;
  classes?: Partial<ClassNameMap<TeamInfoClassKey>>;
}) {
  return team ? (
    <sx.Container
      className={clsx(classes?.container, className)}
      title={team.name}
    >
      <TeamIcon className={classes?.icon} />
      <sx.TeamName className={classes?.name} tooltip={false}>
        {team.name}
      </sx.TeamName>
    </sx.Container>
  ) : null;
}
